import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["Component", "use", "children", "style", "className"];
import { useState, useCallback } from 'react';
import { fromJS, List } from 'immutable';
import { useDataFetchingClient } from 'data-fetching-client';
import { OLAF, BATTLESHIP } from 'HubStyleTokens/colors';
import { getWhiteness } from '../../utils/colors';
import { canReadText, getTextColor } from '../../utils/colors';
import { rgba } from 'UIComponents/core/Color';
import { GET_CHECKOUT_SESSION } from '../../data/queries';
import { jsx as _jsx } from "react/jsx-runtime";
const PRIMARY_COLOR_USE = List(['primary-color', 'primary-color-secondary', 'primary-color-link']);
/**
 * Makes a readable button given different background colors
 * @deprecated See description of https://git.hubteam.com/HubSpotProtected/payments-ui/pull/350
 * For context, ticket to replace at https://git.hubteam.com/HubSpot/Buyer-Exp-Issues/issues/511
 */
const CustomColorButton = _ref => {
  let {
      Component,
      use,
      children,
      style,
      className
    } = _ref,
    transferrableProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const client = useDataFetchingClient();
  const queryData = client.readQuery({
    query: GET_CHECKOUT_SESSION
  });
  const data = queryData && queryData.checkoutSession;
  const primaryColor = fromJS(data).getIn(['branding', 'primaryColor']);
  const [hovered, setHovered] = useState(false);
  const getButtonUse = useCallback(() => {
    if (use && !PRIMARY_COLOR_USE.includes(use)) {
      return use;
    }
    if (use === 'primary-color-link') {
      return 'link';
    }

    // Return a use override so the spinner renders correctly when using
    // UILoadingButton
    return getTextColor(primaryColor) === OLAF ? 'secondary-ghost' : 'primary-white';
  }, [use, primaryColor]);
  const getButtonStyle = useCallback(() => {
    if (use && !PRIMARY_COLOR_USE.includes(use)) {
      return style;
    }
    if (getWhiteness(primaryColor)) {
      const backgroundColor = hovered ? rgba(primaryColor, 0.8) : primaryColor;
      return Object.assign({}, style, {
        borderColor: BATTLESHIP,
        backgroundColor
      });
    }
    if (use === 'primary-color-link') {
      return canReadText(OLAF, primaryColor) ? Object.assign({}, style, {
        color: primaryColor
      }) : style;
    }
    if (use === 'primary-color-secondary') {
      const backgroundColor = hovered ? rgba(primaryColor, 0.05) : OLAF;
      return Object.assign({}, style, {
        color: primaryColor,
        borderColor: primaryColor,
        backgroundColor
      });
    }
    const backgroundColor = hovered ? rgba(primaryColor, 0.8) : primaryColor;
    return Object.assign({}, style, {
      color: getTextColor(primaryColor),
      borderColor: primaryColor,
      backgroundColor
    });
  }, [hovered, primaryColor, style, use]);
  return /*#__PURE__*/_jsx(Component, Object.assign({}, transferrableProps, {
    role: "button",
    className: `custom-color-button ${className}`,
    use: getButtonUse(),
    style: getButtonStyle(),
    onMouseEnter: () => setHovered(true),
    onMouseLeave: () => setHovered(false),
    children: children
  }));
};
export default CustomColorButton;